module.exports = __webpack_public_path__ + "public/img/播放.5adef119.svg";